/* global axios */
import ApiClient from './ApiClient';

class CondoAccessAPI extends ApiClient {
  constructor() {
    super('condo_accesses', { accountScoped: true });
  }

  getAccessibleCondos() {
    return axios.get(`${this.url}/accessible_condos`);
  }

  getTeamCondos(teamId) {
    return axios.get(`${this.url}/teams/${teamId}/condos`);
  }

  assignCondoToTeam({ teamId, condoId, condoName, datasetId }) {
    return axios.post(`${this.url}/teams/${teamId}/condos`, {
      condo_id: condoId,
      condo_name: condoName,
      dataset_id: datasetId,
    });
  }

  batchAssignCondosToTeam({ teamId, condos }) {
    return axios.post(`${this.url}/teams/${teamId}/condos/batch`, {
      condos: condos,
    });
  }

  removeCondoFromTeam({ teamId, condoId }) {
    return axios.delete(`${this.url}/teams/${teamId}/condos/${condoId}`);
  }
}

export default new CondoAccessAPI();
